import { Col, Row, Form as BForm, Dropdown } from '@themesberg/react-bootstrap'
import React, { useEffect, useState } from 'react'
import { safeStringify } from '../../utils/helpers'
import CodepenEditor from '../CodeEditor'
import { ErrorMessage } from 'formik'

export const CreatePromotionsTemplate = ({
  cmsKeys,
  setFieldValue,
  handleChange,
  handleBlur,
  selectedTab,
  title,
  setTitle,
  setDescription,
  content,
  description,
  setContent,
  values
}) => {
  const [template, setTemplate] = useState(values.content)
  const [err, setErr] = useState('')
  const [label, setLabel] = useState(values.title)
  const [descript, setDescript] = useState(values.description)
  const [requiredKeyData, setRequiredKeyData] = useState({})
  console.log('values.redirectUrlToggle', values.redirectUrlToggle);
  useEffect(() => {
    if (cmsKeys?.dynamicKeys && Object.keys(cmsKeys?.dynamicKeys)?.length) {
      let tempDataAll = {}
      let tempData = {}
      const dynamicKeys = cmsKeys?.dynamicKeys
      dynamicKeys.forEach((item) => {
        tempDataAll = { ...tempDataAll, [item.key]: item.description }
        if (item.required) {
          tempData = { ...tempData, [item.key]: item.description }
        }
      })
      setRequiredKeyData(tempData)
    }
  }, [cmsKeys?.dynamicKeys])

  useEffect(() => {
    if (template) {
      setErr('')
    }
    const delayDebounceFn = setTimeout(() => {
      setContent({
        ...content,
        [selectedTab]: template
      })
      setFieldValue('content', template)
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [template])

  useEffect(() => {
    setFieldValue && setFieldValue('language', selectedTab)
    setLabel(label)
  }, [selectedTab])

  useEffect(() => {
    setFieldValue && setFieldValue('title', label)
    setTitle({
      ...title,
      [selectedTab]: label
    })
  }, [label])

  useEffect(() => {
    setFieldValue && setFieldValue('description', descript)
    setDescription({
      ...description,
      [selectedTab]: descript
    })
  }, [descript])

  return (
    <>
      <Col className='mt-3'>
        <Col className='mb-3'>
          <Col xs={2} >
            <BForm.Label>
              Title <span className='text-danger'>* </span>
            </BForm.Label>
          </Col>

          <Col xs={5}>
            <BForm.Control
              type='text'
              name='title'
              placeholder='Enter Title'
              value={label}
              onChange={(e) => {
                setLabel(e.target.value)
                handleChange(e)
              }}
              onBlur={handleBlur}
            />
            <ErrorMessage
              component='div'
              name='title'
              className='text-danger'
            />

          </Col>
        </Col>
        {
          !values.redirectUrlToggle === true ? 
          <Col className='mb-3'>
          <Col xs={2}>
            <BForm.Label>
              Description <span className='text-danger'>* </span>
            </BForm.Label>
          </Col>

          <Col xs={5}>
            <BForm.Control
              type='text'
              name='description'
              as="textarea"
              placeholder='Enter Description'
              value={values.description}
              style={{ minHeight: '100px' }}  
              onChange={(e) => {
                setDescript(e.target.value)
                handleChange(e)
              }}
              onBlur={handleBlur}
            />
            <ErrorMessage
              component='div'
              name='description'
              className='text-danger'
            />
          </Col>
        </Col> : <></>
        }
        
      </Col>
      {
       !values.redirectUrlToggle === true ? 
      <Row>
        <Col>
          <div className='d-flex mb-2 align-items-center'>
            <BForm.Label>
              Content <span className='text-danger'>*</span>
            </BForm.Label>
            <Col />
          </div>

          <CodepenEditor
            dynamicData={safeStringify(requiredKeyData, null, 2)}
            HTML={template || ''}
            initial='HTML'
            mobileQuery={800}
            height='80vh'
            setTemplate={setTemplate}
            themeTransitionSpeed={150}
            setRequiredKeyData={setRequiredKeyData}
            selectedTab={selectedTab}
            setTemp={setTemplate}
          />
        </Col>
      </Row> : <></>
      }
      {err &&
        <Row>
          <span className='text-danger'>{err}</span>
        </Row>}
    </>
  )
}
